<template>
  <v-card class="msg-card">
    <!-- Ícono semántico según tipo -->
    <div class="msg-icon-wrap">
      <div class="msg-icon-circle" :class="`msg-icon-circle--${type}`">
        <v-icon class="msg-icon" :class="`msg-icon--${type}`">{{
          iconName
        }}</v-icon>
      </div>
    </div>

    <!-- Texto -->
    <div class="msg-body">
      <h2 class="msg-title">{{ dialog.title }}</h2>
      <div class="msg-message" v-html="dialog.message"></div>
    </div>

    <!-- Acción -->
    <div class="msg-actions">
      <button
        class="msg-btn"
        :class="`msg-btn--${type}`"
        @click="$emit('close')"
      >
        Aceptar
      </button>
    </div>
  </v-card>
</template>

<script>
const TYPE_MAP = {
  success: 'success',
  primary: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
}

const ICON_MAP = {
  success: 'check_circle_outline',
  error: 'error_outline',
  warning: 'warning',
  info: 'info_outline',
}

export default {
  name: 'Message',
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: {
        color: 'primary',
        title: 'Mensaje del Sistema',
        message: '',
      },
    }
  },
  computed: {
    type() {
      return TYPE_MAP[this.dialog.color] || 'info'
    },
    iconName() {
      return ICON_MAP[this.type]
    },
  },
  created() {
    this.dialog = { ...this.dialog, ...this.options }
  },
}
</script>

<style scoped>
.msg-card {
  border-radius: 16px !important;
  overflow: hidden;
  padding: 0;
}

/* ── Ícono ─────────────────────────────────── */
.msg-icon-wrap {
  display: flex;
  justify-content: center;
  padding: 28px 24px 0;
}

.msg-icon-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Success / primary */
.msg-icon-circle--success {
  background: #f0fdf4;
  border: 5px solid #bbf7d0;
}
.msg-icon--success {
  color: #16a34a !important;
  font-size: 26px !important;
}

/* Error */
.msg-icon-circle--error {
  background: #fef2f2;
  border: 5px solid #fee2e2;
}
.msg-icon--error {
  color: #e5252a !important;
  font-size: 26px !important;
}

/* Warning */
.msg-icon-circle--warning {
  background: #fffbeb;
  border: 5px solid #fde68a;
}
.msg-icon--warning {
  color: #d97706 !important;
  font-size: 26px !important;
}

/* Info */
.msg-icon-circle--info {
  background: #eff6ff;
  border: 5px solid #bfdbfe;
}
.msg-icon--info {
  color: #2563eb !important;
  font-size: 26px !important;
}

/* ── Texto ─────────────────────────────────── */
.msg-body {
  padding: 16px 28px 4px;
  text-align: center;
}

.msg-title {
  font-size: 17px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 8px;
  letter-spacing: -0.01em;
}

.msg-message {
  font-size: 14px;
  color: #64748b;
  line-height: 1.65;
}

/* ── Botón ─────────────────────────────────── */
.msg-actions {
  padding: 20px 28px 24px;
  display: flex;
  justify-content: center;
}

.msg-btn {
  min-width: 120px;
  height: 42px;
  padding: 0 28px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.18s ease;
  letter-spacing: 0.01em;
  color: #ffffff;
}

.msg-btn--success {
  background: #16a34a;
  box-shadow: 0 2px 8px rgba(22, 163, 74, 0.25);
}
.msg-btn--success:hover {
  background: #15803d;
}

.msg-btn--error {
  background: #e5252a;
  box-shadow: 0 2px 8px rgba(229, 37, 42, 0.25);
}
.msg-btn--error:hover {
  background: #c91e23;
}

.msg-btn--warning {
  background: #d97706;
  box-shadow: 0 2px 8px rgba(217, 119, 6, 0.25);
}
.msg-btn--warning:hover {
  background: #b45309;
}

.msg-btn--info {
  background: #2563eb;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);
}
.msg-btn--info:hover {
  background: #1d4ed8;
}
</style>
